import "./App.scss";
import AppContainer from "./components/AppContainer/AppContainer";

function App() {
  return (
    <div className="App">
      <AppContainer/>
    </div>
  );
}

export default App;
